import React from "react";
import { ShieldCheck, User, Mail, Image as ImageIcon } from "lucide-react";

const SecaoLoginGoogle = () => {
  return (
    <section
      id="login-google"
      className="py-20 px-4 border-t border-white/5"
      data-testid="secao-login-google"
    >
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-emerald-500/10 border border-emerald-500/20 mb-4">
            <ShieldCheck className="w-4 h-4 text-emerald-400" />
            <span className="text-emerald-400 text-sm font-medium">Privacidade e segurança</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Login com sua conta Google
          </h2>
          <p className="text-white/60 text-lg max-w-2xl mx-auto">
            O Evolzap usa sua conta Google apenas para autenticar o acesso ao sistema. Nenhum outro dado da sua conta é lido, movimentado ou compartilhado.
          </p>
        </div>

        <div className="bg-white/5 border border-white/10 rounded-2xl p-8 md:p-10">
          <h3 className="text-white text-xl font-semibold mb-6">
            O que coletamos ao entrar com o Google
          </h3>

          <div className="grid md:grid-cols-3 gap-6 mb-8">
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-lg bg-emerald-500/10 flex items-center justify-center flex-shrink-0">
                <User className="w-5 h-5 text-emerald-400" />
              </div>
              <div>
                <h4 className="text-white font-medium mb-1">Nome do perfil</h4>
                <p className="text-white/50 text-sm">Nome público exibido na sua conta Google</p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-lg bg-emerald-500/10 flex items-center justify-center flex-shrink-0">
                <Mail className="w-5 h-5 text-emerald-400" />
              </div>
              <div>
                <h4 className="text-white font-medium mb-1">Endereço de e-mail</h4>
                <p className="text-white/50 text-sm">Usado para identificar sua conta no sistema</p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-lg bg-emerald-500/10 flex items-center justify-center flex-shrink-0">
                <ImageIcon className="w-5 h-5 text-emerald-400" />
              </div>
              <div>
                <h4 className="text-white font-medium mb-1">Foto de perfil</h4>
                <p className="text-white/50 text-sm">Avatar público exibido dentro do Evolzap</p>
              </div>
            </div>
          </div>

          <div className="space-y-4 text-white/70 text-sm leading-relaxed border-t border-white/10 pt-6">
            <p>
              <span className="text-white font-medium">O que NÃO fazemos:</span> não lemos e-mails do Gmail, não acessamos sua agenda, não movimentamos arquivos do Drive, não postamos em seu nome. O escopo solicitado é apenas o básico de identificação (<code className="text-emerald-400 bg-black/30 px-1.5 py-0.5 rounded text-xs">openid</code>, <code className="text-emerald-400 bg-black/30 px-1.5 py-0.5 rounded text-xs">email</code>, <code className="text-emerald-400 bg-black/30 px-1.5 py-0.5 rounded text-xs">profile</code>).
            </p>
            <p>
              <span className="text-white font-medium">Uso dos dados:</span> os dados coletados são usados exclusivamente para criar e identificar sua conta no Evolzap. Não vendemos, alugamos nem compartilhamos essas informações com terceiros para fins de marketing.
            </p>
            <p>
              <span className="text-white font-medium">Revogação de acesso:</span> você pode remover a autorização a qualquer momento em{" "}
              <a
                href="https://myaccount.google.com/permissions"
                target="_blank"
                rel="noopener noreferrer"
                className="text-emerald-400 hover:text-emerald-300 underline"
              >
                myaccount.google.com/permissions
              </a>.
            </p>
            <p>
              <span className="text-white font-medium">Mais detalhes:</span> consulte nossa{" "}
              <a
                href="https://app.evolzap.com/legal/privacidade.html"
                target="_blank"
                rel="noopener noreferrer"
                className="text-emerald-400 hover:text-emerald-300 underline"
              >
                Política de Privacidade
              </a>{" "}
              e nossos{" "}
              <a
                href="https://app.evolzap.com/legal/termos.html"
                target="_blank"
                rel="noopener noreferrer"
                className="text-emerald-400 hover:text-emerald-300 underline"
              >
                Termos de Serviço
              </a>.
            </p>
          </div>

          <div className="mt-8 pt-6 border-t border-white/10 text-center">
            <a
              href="https://app.evolzap.com/login"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-emerald-500 hover:bg-emerald-600 text-white font-medium transition-colors"
            >
              Acessar o Evolzap
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SecaoLoginGoogle;
